import React from 'react';
import { Dialog } from 'primereact/dialog';
import { TruckHandlingUnit } from '../api';
import { formatDateTime } from '../utils';
import { HandlingUnitStage, HandlingUnitLocation } from '../types/purchaseOrder';

interface HandlingUnitDetailsDialogProps {
  visible: boolean;
  onHide: () => void;
  handlingUnit: TruckHandlingUnit | null;
}

const HandlingUnitDetailsDialog: React.FC<HandlingUnitDetailsDialogProps> = ({
  visible,
  onHide,
  handlingUnit
}) => {
  if (!handlingUnit) return null;

  const renderField = (label: string, value: any) => (
    <div className="p-field mb-3">
      <label className="block text-900 font-medium mb-2">{label}</label>
      <div className="p-2 surface-100 border-round">{value || 'Not assigned'}</div>
    </div>
  );

  return (
    <Dialog
      header={`Handling Unit Details - ${handlingUnit.huNumber}`}
      visible={visible}
      onHide={onHide}
      style={{ width: '90vw', maxWidth: '600px' }}
      modal
      className="p-fluid"
    >
      <div className="grid">
        <div className="col-12">
          {renderField('HU Number', handlingUnit.huNumber)}
          {renderField('PO Number', handlingUnit.poNumber)}
          {renderField('Item Number', handlingUnit.itemNumber)}
          {renderField('Product Name', handlingUnit.productName)}
          {renderField('Stage', handlingUnit.stage)}
          {renderField('Location', handlingUnit.location)}
          {renderField('Received Count', handlingUnit.receivedCount)}
          {renderField('Truck Assignment', 
            handlingUnit.handlingUnitOutboundTruckNumber 
              ? `Truck #${handlingUnit.handlingUnitOutboundTruckNumber}` 
              : 'Not assigned'
          )}
          {renderField('Truck Assignment Date', 
            handlingUnit.huTruckDateTime 
              ? formatDateTime(new Date(handlingUnit.huTruckDateTime))
              : 'Not assigned'
          )}
          {renderField('Delivery Date',
            handlingUnit.deliveryDate
              ? formatDateTime(new Date(handlingUnit.deliveryDate))
              : 'Not assigned'
          )}
        </div>

        {handlingUnit.history && handlingUnit.history.length > 0 && (
          <div className="col-12">
            <h3 className="text-xl font-medium mb-3">History</h3>
            <div className="surface-50 border-round p-3">
              {handlingUnit.history.map((entry, index) => (
                <div key={index} className="mb-3 p-3 surface-100 border-round">
                  <div className="text-sm text-500">
                    {formatDateTime(new Date(entry.timestamp))}
                  </div>
                  <div className="font-medium">{entry.action}</div>
                  <div>by {entry.user}</div>
                  {entry.details && (
                    <div className="text-sm mt-2 text-600">{entry.details}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default HandlingUnitDetailsDialog;
